'use client';

import type { UseFormRegister } from 'react-hook-form';

const inputBaseClass =
  'w-full px-4 py-3 rounded-xl border text-sm text-[#373A36] placeholder-[#b0b3ac] focus:outline-none focus:ring-2 focus:ring-[#00A19B]/20 transition-all motion-reduce:transition-none';

const fieldBorder = (hasError: boolean) =>
  hasError ? 'border-red-400 focus:border-red-500' : 'border-[#E8E8E4] focus:border-[#00A19B]';

type Props = {
  name: string;
  label: string;
  register: UseFormRegister<any>;
  error?: string;
  options: ReadonlyArray<{ value: string; label: string }>;
  placeholder: string;
  required?: boolean;
};

export function SelectField({
  name,
  label,
  register,
  error,
  options,
  placeholder,
  required,
}: Props) {
  const fieldId = `field-${name}`;
  const errorId = `${fieldId}-error`;

  return (
    <div>
      <label htmlFor={fieldId} className="block text-sm font-semibold text-[#373A36] mb-2">
        {label}
        {required && <span className="text-red-500 font-bold ml-0.5">*</span>}
      </label>
      <select
        id={fieldId}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        className={`${inputBaseClass} ${fieldBorder(!!error)} bg-white`}
        {...register(name)}
      >
        <option value="">{placeholder}</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {error && (
        <p id={errorId} className="mt-1 text-xs text-red-500">
          {error}
        </p>
      )}
    </div>
  );
}
